import React, { Component } from 'react';
import UserRolesDropDown from './UserRolesDropDown'
class OverviewTab extends Component {
        permissions = (userRole) => {
            let permission = {"Artisan" : ["Viewing and Completing Work Instruction"],
                "Work Lead" : ["The progress Tracking of Artisans", "Viewing of the work Instructions and Management Pages"],
                "Shop Supervisor": ["The progress Tracking of Artisans", "Viewing of the work Instructions and Management Pages", "Device Authorization"],
                "Engineer" : ["Authoring and Previewing Work Instructions", "Model Uploadering"],
                "E&E" : ["Assisting Engineers with Authoring of Work Instructions"],
                "QA" : ["At this point in time, this role does not have functionality on the web application."],
                "Dev": ["Developing AVARIS"]
            }
            return permission[userRole]
        }

        renderPermissions = (userRole) => {
            let permissions = []
            this.permissions(userRole).forEach((permission, index) =>
                    permissions.push(<li key={index}>{permission}</li>)
            )
            return <ul id="permissions-list">
                Permissions Include:
                {permissions}
                </ul>
        }

        render() {
            return <div id="user-summary-info" className="flex-column">
                <div className="flex" style={{alignItems: "flex-end", marginBottom: "1.25em"}}>
                    <div style={{marginRight: ".25em"}}>{this.props.user.username} Role: </div>
                        <UserRolesDropDown 
                            // options={["Artisan", "Work Lead", "Shop Supervisor", "Engineer", "E&E", "QA", "Production Controller"]}
                            options={["Artisan", "Work Lead", "Shop Supervisor", "Engineer", "E&E", "QA"]}
                            selection={this.props.user.role}
                            selectOption={this.props.modifyRole}
                            />
                    </div>
                        {this.renderPermissions(this.props.user.role)}
            </div>
    }
}
export default OverviewTab